import { useCallback } from 'react';
import { useApiData, useAuthenticatedFetch } from '../client';
import type { StaticReflection, StaticReflectionStatus } from '../../types/media-sim';

export function useStaticReflection(publicationId: string) {
  const { data, loading, error, refetch } = useApiData<StaticReflection>(
    `/media-sim/publications/${publicationId}/static-reflection`
  );
  return { reflection: data, loading, error, refetch };
}

export function useStaticReflectionStatus(publicationIds: string[]) {
  const ids = publicationIds.join(',');
  const { data, loading, error, refetch } = useApiData<{ statuses: StaticReflectionStatus[] }>(
    ids ? `/media-sim/publications/static-reflection-status?publication_ids=${ids}` : ''
  );
  return { statuses: data?.statuses ?? [], loading, error, refetch };
}

export function useRegenerateStaticReflection() {
  const { fetchData, loading } = useAuthenticatedFetch<StaticReflection>();
  const regenerate = useCallback(
    (publicationId: string, lookbackDays?: number) =>
      fetchData(`/media-sim/publications/${publicationId}/static-reflection/regenerate`, {
        method: 'POST',
        body: JSON.stringify({ lookback_days: lookbackDays ?? 365 }),
      }),
    [fetchData]
  );
  return { regenerate, loading };
}
